<script setup lang="ts">
import { usePageStore } from '@/page/infrastructure/composition/usePageStore';

type Props = {
  redirectButtonText?: string;
}
const props = defineProps<Props>();

const { pageState } = usePageStore();
</script>

<template>
    <get-quote-banner class="w-full" v-if="pageState.appsEnabled" :applications="JSON.stringify(pageState.appsEnabled)" :button-text="props.redirectButtonText" ></get-quote-banner>
</template>
